import React from 'react';
import css from './EmptyWidget.module.scss';
import { useTranslation } from 'react-i18next';
import KalmarLogo from '../../assets/kalmar-logo-new-round-red.svg';
import CreateCaseIcon from '../../assets/new-case-icon.svg';
import EquipmentEvolution from '../../assets/equipment-icons/equipment-evolution.svg';
import ShoppingCartIcon from '../../assets/empty-my-parts-widget-icon.svg';

export interface EmptyWidgetProps {
    type: 'equipment' | 'cases' | 'insight' | 'parts';
}

interface MyKalmarLogoProps {
    serviceTitle?: string;
}

const MyKalmarLogo: React.FunctionComponent<MyKalmarLogoProps> = ({ serviceTitle }: MyKalmarLogoProps) => (
    <div className={css.logo}>
        <KalmarLogo />
        <div className={css.red}>My</div>
        <div>Kalmar</div>
        {serviceTitle && <div className={css.customTitle}> {serviceTitle}</div>}
    </div>
);
export const EmptyWidget: React.FunctionComponent<EmptyWidgetProps> = ({ type }: EmptyWidgetProps) => {
    const { t } = useTranslation('EmptyWidgets');

    const renderContent = () => {
        switch (type) {
            case 'equipment':
                return (
                    <>
                        <EquipmentEvolution className={css.icon} />
                        <div className={css.text}>
                            <div>{t('By registering your equipment you can see manuals, contracts and more.')}</div>
                        </div>
                    </>
                );
            case 'cases':
                return (
                    <>
                        <CreateCaseIcon className={css.icon} />
                        <div className={css.text}>
                            <div>{t('Do you have an inquiry?')}</div>
                            <div>{t('Create a case')}</div>
                        </div>
                    </>
                );
            case 'parts':
                return (
                    <>
                        <ShoppingCartIcon className={css.icon} />
                        <MyKalmarLogo serviceTitle="STORE" />
                        <div className={css.text}>
                            <div>{t('Buy genuine parts')}</div>
                        </div>
                    </>
                );
            case 'insight':
                return (
                    <>
                        <MyKalmarLogo serviceTitle="INSIGHT" />
                        <div className={css.text}>
                            <div>{t('Performance management tool for cargo handling operations')}</div>
                        </div>
                    </>
                );
            default:
                return (
                    <>
                        <MyKalmarLogo serviceTitle="Services" />
                        <div className={css.text}>
                            <div>{t('Kalmar Services')}</div>
                        </div>
                    </>
                );
        }
    };

    return <div className={css.emptyWidget}>{renderContent()}</div>;
};
